import { Yup } from 'src/helpers/Yup';
import { onlyDigits } from 'src/helpers/string';

export const placeOfServiceSchema = Yup.object().shape({
  placeName: Yup.string().required('Informe o nome do local de atendimento.'),
  phoneNumber: Yup.string()
    .required('Informe um número de telefone válido.')
    .test('validate phoneNumber', 'Informe um número de telefone válido.', function (phoneNumber) {
      if (!phoneNumber) return false;
      return onlyDigits(phoneNumber).length === 10 || onlyDigits(phoneNumber).length === 11;
    }),
  postalCode: Yup.string()
    .required('Informe um CEP válido.')
    .test('validate postal code', 'Informe um CEP válido.', function (postalCode) {
      return onlyDigits(postalCode || '').length === 8;
    }),
  address: Yup.string().required('Informe um endereço válido.'),
  houseNumber: Yup.string().required('Informe um número válido.'),
  district: Yup.string().required('Informe um bairro válido.'),
  complement: Yup.string().nullable(),
  city: Yup.string().required('Informe uma cidade válida.'),
  state: Yup.string().required('Informe uma UF válida.'),
});
